import Api from '../global/api';  
const berthPedestalReducer = (state = {
    status: 'LOADING',
    msg: '',
    data: []
}, action) => {
    let current_data = JSON.parse(JSON.stringify(state.data));
    const status = typeof action.status !== 'undefined' ? action.status.toUpperCase(): null;
    const idx = status === 'OK' ? current_data.findIndex(c => c.id_berth === action.payload.id_berth && c.id_pedestal === action.payload.id_pedestal) : -1;

    switch(action.type){
        case "BERTH_PEDESTALS_LOAD":
            state = {
                ...state,
                status: status,
                msg: status === 'ERROR'?action.payload:'',
                data: status === 'OK'?action.payload:current_data
            }
            break;
        case "BERTH_PEDESTAL_ADD":
            if(status === 'OK' && idx > -1)
                current_data[idx] = action.payload;
            else
                current_data.push(action.payload);

            state = {
                ...state,
                status: status,
                msg: status === 'ERROR'?action.payload:'',
                data: current_data
            }
            break;
        case "BERTH_PEDESTAL_REMOVE":
            if(status === 'OK' && idx > -1)
                current_data.splice(idx, 1);
                
            state = {
                ...state,
                status: status,
                msg: status === 'ERROR'?action.payload:'',
                data: current_data
            }
            Api.setLocal('berth_pedestals', current_data);
            break;
        default:
    }
    return state;
}

export default berthPedestalReducer;